import classes from './Header.module.scss';
import NavLinks from 'components/layout/NavLinks';
import { useRef, forwardRef, useImperativeHandle } from 'react';
import { useState } from 'react';

const Header = forwardRef((props, ref) => {
  const headerRef = useRef();
  const [menuIsActive, setMenuIsActive] = useState(false);

  const menuClickHandler = (e) => {
    setMenuIsActive(!menuIsActive);
  }

  const closeMobileMenu = () => {
    setMenuIsActive(false);
  }

  const detachHeader = () => {
    headerRef.current.classList.add('header--detach');
  }

  const attachHeader = () => {
    headerRef.current.classList.remove('header--detach');
  }

  const scrollToSection = (e) => {
    e.preventDefault();
  
    const linkSection = document.getElementById("home");
    linkSection && linkSection.scrollIntoView({ behavior: "smooth", block: "start"});

    closeMobileMenu();
  }

  useImperativeHandle(ref, () => {
    return {
      detach: detachHeader,
      attach: attachHeader
    };
  });

  return (
    <header className={classes.header} ref={headerRef}>
      <div className="container">
        <a href="#home" className={classes.logolink} onClick={scrollToSection}>
          <i className="icon icon-logo">
            <span className="path1"></span>
            <span className="path2"></span>
          </i>
          <span className="sr-only">mjbaga.tech</span>
        </a>
        <button className={`${classes["menu-btn"]} ${menuIsActive ? classes.active : '' }`} onClick={menuClickHandler} >
          <span className="sr-only">Toggle mobile menu</span>
          <span className={classes.line}></span>
          <span className={classes.line}></span>
          <span className={classes.line}></span>
          <span className={classes.line}></span>
        </button>
        <NavLinks isActive={menuIsActive} closeMenu={closeMobileMenu} />
      </div>
    </header>
  )
})

export default Header;